/** Opciones compartidas: Observador, supervisor integrado y Jornada. */

export const OBSERVADOR_DOMAIN_OPTIONS = [
    {
        value: 'vitalidad',
        label: 'Vitalidad',
        hint: 'Energía, descanso, salud percibida o fatiga.',
        alineaBrief: 'Cómo está tu energía para sostener el día.',
    },
    {
        value: 'vinculos',
        label: 'Vínculos',
        hint: 'Relaciones, clima, comunicación o pertenencia.',
        alineaBrief: 'Cómo te conectas con el equipo y el entorno.',
    },
    {
        value: 'nucleo_afectivo',
        label: 'Núcleo afectivo',
        hint: 'Carga emocional profunda, familia o soporte personal.',
        alineaBrief: 'Lo que sostiene o pesa en tu vida personal.',
    },
    {
        value: 'estabilidad_economica',
        label: 'Estabilidad económica',
        hint: 'Presión financiera, futuro o seguridad material.',
        alineaBrief: 'Tranquilidad o tensión por ingresos y gastos.',
    },
];

export const OBSERVADOR_BODY_SIGNALS = [
    { value: 'estable', label: 'Estable' },
    { value: 'tension', label: 'Tensión' },
    { value: 'agotamiento', label: 'Agotamiento' },
];

export const OBSERVADOR_WORK_FRICTION = [
    { value: 'baja', label: 'Baja' },
    { value: 'alta', label: 'Alta' },
    { value: 'relaciones', label: 'Relacional' },
];

export const OBSERVADOR_SUPPORT_NEEDS = [
    { value: 'claridad', label: 'Claridad' },
    { value: 'pausa', label: 'Pausa' },
    { value: 'conversacion', label: 'Conversación' },
];

export const OBSERVADOR_ENERGY_LABELS = [
    { level: 1, label: 'Muy baja' },
    { level: 2, label: 'Baja' },
    { level: 3, label: 'Media' },
    { level: 4, label: 'Bastante' },
    { level: 5, label: 'Alta' },
];

export const OBSERVADOR_REFLECTION_CHIPS = [
    { emoji: '🧭', text: 'Necesito ordenar prioridades.' },
    { emoji: '🤝', text: 'Me vendría bien apoyo o una conversación breve.' },
    { emoji: '😮‍💨', text: 'Llevo carga acumulada.' },
    { emoji: '⚡', text: 'El ritmo se siente intenso.' },
    { emoji: '🏠', text: 'Mezcla trabajo con cosas de casa o familia.' },
];

/** Etiqueta de fase de check-in devuelta por el API tras guardar. */
export function checkinPhaseLabel(phase) {
    if (phase === 'end') return 'Cierre de jornada registrado';
    if (phase === 'start') return 'Llegada registrada';
    return 'Check-in guardado';
}
